<ng-container>
  <div class="myaccount-employee-wrapper" *ngIf="isManageEmployeesEnabled$ | async">
    <h2 *ngIf="itemCount !== undefined">
      {{ 'myAccount.manageEmployees' | cxTranslate }}
    </h2>
    <div class="myaccount-sort-edit" *ngIf="itemCount > 0">
      <app-sorting
        [sortOptions]="sortOptions"
        [sortLabels]="sortLabels | async"
        (sortListEvent)="sortChange($event)"
        [selectedOption]="sort"
      >
      </app-sorting>
      <div class="myaccount-edit">
        <a [routerLink]="'add-employee'"
          ><mat-icon class="material-icons-sharp light add-employee">add</mat-icon
          >{{ 'myAccount.addEmployee' | cxTranslate }}</a
        >
      </div>
    </div>
    <div class="myaccount-table-wrapper" *ngIf="itemCount > 0 && isDesktop">
      <app-table [columns]="columns" [dataSource]="dataSource" [pageSize]="10" [paginator]="null"> </app-table>
    </div>
    <ng-container *ngIf="itemCount > 0 && !isDesktop">
      <ng-container *ngIf="managementEmployees$ | async as managementEmployees">
        <div class="myaccount-tablet-mobile" *ngFor="let employee of managementEmployees.entries">
          <div class="divider-tablet">
            <div class="divider1">
              <div class="myaccount-fname-wrapper">
                <p class="label">{{ 'myAccount.firstName' | cxTranslate }}</p>
                <p class="data">{{ employee?.firstName }}</p>
              </div>
              <div class="myaccount-lname-wrapper">
                <p class="label">{{ 'myAccount.lastName' | cxTranslate }}</p>
                <p class="data">{{ employee?.lastName }}</p>
              </div>
            </div>
            <div class="divider2">
              <div class="myaccount-email-wrapper">
                <p class="label">{{ 'myAccount.emailAddress' | cxTranslate }}</p>
                <p class="data">{{ employee?.email }}</p>
              </div>
            </div>
          </div>
          <div class="divider-delivery-status">
            <div class="myaccount-delivery-add-wrapper">
              <p class="label">{{ 'myAccount.deliveryAddress' | cxTranslate }}</p>
              <ng-container
                *ngIf="(showAddressName$ | async) && employee?.defaultAddress?.addressName; else showAddress"
              >
                <p class="data">
                  <span class="address-name">{{ employee?.defaultAddress?.addressName }}: </span
                  >{{ employee?.defaultAddress?.formattedAddress }}
                </p>
              </ng-container>
              <ng-template #showAddress>
                <p class="data">{{ employee?.defaultAddress?.formattedAddress }}</p>
              </ng-template>
            </div>
            <div class="myaccount-status-wrapper">
              <p class="label">{{ 'myAccount.status' | cxTranslate }}</p>
              <p>
                <span class="inactive-status" [ngClass]="{ 'active-status': employee?.active === true }">{{
                  employee?.active ? ('myAccount.active' | cxTranslate) : ('myAccount.inactive' | cxTranslate)
                }}</span>
              </p>
            </div>
          </div>
          <button
            (click)="
              onClickEdit(
                employee?.active,
                employee?.lastName,
                employee?.firstName,
                employee?.email,
                employee?.jobTitle,
                employee?.defaultAddress?.id,
                employee?.defaultAddress?.formattedAddress,
                employee?.uid,
                employee?.storeFrontPermissions
              )
            "
            class="btn-edit-employee"
            mat-button
            [routerLink]="'/my-account/edit-employee'"
          >
            <mat-icon class="material-icons-sharp light add-employee">create</mat-icon>
          </button>
        </div>
      </ng-container>
    </ng-container>

    <div id="pagination-wrapper-component" *ngIf="itemCount > 0">
      <app-pagination
        (viewPageEvent)="pageChange($event)"
        [pagination]="PaginationModel"
        [hideOnSinglePage]="true"
      ></app-pagination>
    </div>
    <div class="myaccount-sort-edit no-record-add" *ngIf="itemCount === 0">
      <div class="myaccount-edit">
        <a [routerLink]="'add-employee'"
          ><mat-icon class="material-icons-sharp light add-employee">add</mat-icon
          >{{ 'myAccount.addEmployee' | cxTranslate }}</a
        >
      </div>
    </div>
    <p class="myaccount-no-records" *ngIf="itemCount === 0">{{ 'myAccount.noRecords' | cxTranslate }}</p>
  </div>
</ng-container>
